import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'
import type * as rxjs from 'rxjs'

import * as gql from '../../gql'

import type { Context } from './types'

/**
 * API used by the records bulk comment workflow
 */
@ngCore.Injectable()
export class Api {
  /**
   * Applies one comment to every record in the context.
   */
  public update({
    context,
    comment,
  }: Api.Update.Params): rxjs.Observable<
    readonly ents.extra.space.Record.Id[]
  > {
    return gql.mutations.bulkUpdateSpaceRecords.executor({
      ...context,
      update: { comment },
    })
  }
}

export namespace Api {
  export namespace Update {
    /** {@link Context}, with the comment to apply */
    export interface Params {
      readonly context: Context
      readonly comment: string
    }
  }
}
